import api from 'api/api';
import axios from 'axios';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {randomFlipCardReward} from 'api/apiHelper';

export const fetchRandomFlipCardReward = createAsyncThunk(
  'flipCard/fetchRandomFlipCardReward',
  async (arg, {getState, signal}) => {
    const state = await getState();
    const uuid = state.user.profile.uuid;
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    const response = await api(randomFlipCardReward({uuid, ...arg}, {cancelToken: source.token}));
    return response.data;
  }
);

const extraReducers = {
  [fetchRandomFlipCardReward.pending]: (state, action) => {
    state.randomResult = {...action.payload, loading: true};
  },
  [fetchRandomFlipCardReward.fulfilled]: (state, action) => {
    state.randomResult = {...action.payload, loading: false};
  },
};

const name = 'flipCardReward';

const initialState = {
  randomResult: {},
};

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers,
});

export const {reset} = slice.actions;

export default slice.reducer;
